import React, { Fragment, useState } from "react";
import {
  Badge,
  Button,
  Col,
  Input,
  InputGroup,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import AddCommander from "./AddCommander";
import { useEffect } from "react";
import axios from "axios";
import { GetCookieToken } from "../../Cookie/GetCookie";
import EditCommander from "./EditCommander";
import dayjs from "dayjs";
import LoadingData from "../../TESTPage/LoadingData";
import FadeIn from "react-fade-in/lib/FadeIn";
import { FetchAxiosGet, FetchAxiosPut } from "../../../api/axios";
import ConfirmModal from "../../../components/Common/ConfirmModal";
import { useNavigate } from "react-router-dom";
import { CheckPosition } from "../../Function/CheckPosition";
import { CheckSubAdmin } from "../../Function/CheckSubAdmin";

const API_URL = process.env.REACT_APP_API_CORS;

function ViewCommander(props) {
  const {userInfo} = props
  const navigate = useNavigate();
  const token = GetCookieToken("userToken");
  const [loading, setLoading] = useState(true);
  const [dataInfo, setDataInfo] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [userDataOrg, setUserDataOrg] = useState([]);
  const [userDataOrgIsDeFault, setUserDataOrgIsDeFault] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [pushkeyword, setPushKeyword] = useState("");
  const [userData, setUserData] = useState([]);
  const [conToPosition, setConToPosition] = useState([]);
  const [keyword, setKeyword] = useState("");

  const [inversedSort, setInversedSort] = useState(false);
  const [indexSort, setIndexSort] = useState(2);

  const [confirmModal, setconfirmModal] = useState(false)
  const [id, setId] = useState()
  const [orgId, setOrgId] = useState()
  const [userID, setUserID] = useState()

  const fetchUserData = ( orderBy = "position_id", sortedBy = "ASC") => {
    const url = `${API_URL}/api/users/position/datatable`;
    const params = new URLSearchParams({
      page: currentPage,
      size: 10,
      "order[0]": orderBy,
      "order[1]": sortedBy,
      "filter[assign][0]": "0",
      "filter[assign][1]": "1",
      search: pushkeyword,
    });
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    axios
      .get(url, config)
      .then(response => {
        setUserData(response.data.result);
        setDataInfo(() => response.data.info);
        setTotalPages(Math.ceil(response.data.info.totalRows / pageSize));
        // const userId = response.data.result?.map(i => i.user_id);
      })
      .catch(error => console.error("Error:", error));
  };

  useEffect(() => {
    setLoading(true);
    fetchUserData();
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, [currentPage, pageSize, pushkeyword,]);

  const handleButtonClick = value => {
    setLoading(true);
    setTimeout(() => {
      fetchUserData();
      setLoading(false);
    }, 1500);
  };

  const handleSearch = () => {
    setPushKeyword(keyword);
  };

  const deleteState = id => {
    setUserData(prevData => prevData.filter(item => item.id !== id));
  };

  const featchDeleteSubAdmin = async (id) =>{
    const params = new URLSearchParams({
      page: 1,
      size: 10,
      "order[0]": "id",
      "order[1]": "ASC",
      "filter[pk_user_position_id][0]": id,
    })
    const resFetch =  await FetchAxiosGet("/api/subAdmin/datatable",token,params)
    if (resFetch.result.length > 0) {
      resFetch?.result?.map( async x => {
        const responseDelete = await axios.delete(`${API_URL}/api/subAdmin/${x?.id}`, {headers: {Authorization: `Bearer ${token}`}});
      })
    }
  }
  
  const fetchDeleteData = async (Data_id, DataUser_id, Data_org) => {
    setLoading(true);
  const conToPosition = await OrgFuctionName(DataUser_id)
    try {

        const contoURLDel = `/api/users/${userID}`;
        let arrayPosition = [2,3,4,5,6,7]
        let data_con_to_id_Del = {
          user_title_id: conToPosition.user_title_id,
          user_title_name: conToPosition.user_title_name,
          user_name: conToPosition.user_name,
          user_idcard: conToPosition.user_idcard,
          user_email: conToPosition.user_email,
          user_login: conToPosition.user_login,
          cont_to_id: 0,
        };
        arrayPosition.forEach(element => { data_con_to_id_Del[`cont_to_id${element}`] = 0 });

        await FetchAxiosPut(contoURLDel, data_con_to_id_Del, token);
            const filtereduserDataOrg = userDataOrg.filter(item => !userDataOrgIsDeFault.includes(item));
            const newFiltereduserDataOrg = filtereduserDataOrg.filter(item => item !== Data_org);
            let uniqueArray = Array.from(new Set(newFiltereduserDataOrg)).filter(item => item !== null);
            // const newUniqueArray = uniqueArray.filter(item => item !== Data_org);

            let data_con_to_id_All = {
              user_title_id: conToPosition.user_title_id,
              user_title_name: conToPosition.user_title_name,
              user_name: conToPosition.user_name,
              user_idcard: conToPosition.user_idcard,
              user_email: conToPosition.user_email,
              user_login: conToPosition.user_login,

            };
            for (let i = 1; i <= uniqueArray.length; i++) {
              const currentNumber = newFiltereduserDataOrg[i - 1];
              if (i == 1) {
                data_con_to_id_All[`cont_to_id`] = Number(currentNumber)
              } else {
                data_con_to_id_All[`cont_to_id${i}`] = Number(currentNumber)
              }
            }
            await FetchAxiosPut(contoURLDel, data_con_to_id_All, token);
            await axios.delete(`${API_URL}/api/users/position/${Data_id}`, { headers: {Authorization: `Bearer ${token}`}});
            
            featchDeleteSubAdmin(Data_id)
            checkOrgUserPosition(DataUser_id);
            checkOrgUserIsDefaultPosition(DataUser_id);
    } catch (error) {
      console.error("Error:", error);
    }

    fetchUserData();
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  };

  const OrgFuctionName = async id => {
    const url = `${API_URL}/api/users/${id}`;
    const params = new URLSearchParams({});
    let dataToFetch;
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    await axios
      .get(url, config)
      .then(response => {
        dataToFetch = response.data.result
      })
      .catch(error => {
        console.error(error);
      });
      return dataToFetch
  };

  const checkOrgUserPosition = async id => {
    const url = `${API_URL}/api/users/position/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 1000,
      "order[0]": "position_id",
      "order[1]": "DESC",
      "filter[assign][0]": "0",
      "filter[user_id][0]": id,
    });
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    await axios
      .get(url, config)
      .then(response => {
        const uniqueOrgIds = new Set(
          response.data.result.map(item => item.org_id)
        );

        // แปลง Set กลับเป็น Array หากต้องการ
        const uniqueOrgIdsArray = Array.from(uniqueOrgIds);

        // ทำสิ่งอื่นๆ ต่อไป
        setUserDataOrg(uniqueOrgIdsArray);
        // const userId = response.data.result?.map(i => i.user_id);
      })
      .catch(error => console.error("Error:", error));
  };

  const checkOrgUserIsDefaultPosition = async id => {
    const url = `${API_URL}/api/users/position/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 1000,
      "order[0]": "position_id",
      "order[1]": "DESC",
      "filter[assign][0]": "0",
      "filter[is_default][0]": "1",
      "filter[user_id][0]": id,
    });
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    await axios
      .get(url, config)
      .then(response => {
        setUserDataOrgIsDeFault(response.data.result.map(i => i.org_id));
        // const userId = response.data.result?.map(i => i.user_id);
      })
      .catch(error => console.error("Error:", error));
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch();
    }
  };

  const headers = [
    { field: "user_name", label: "ชื่อ-นามสกุล" },
    { field: "org_name", label: "สำนัก/กอง/กลุ่ม" },
    { field: "position_id", label: "ตำแหน่ง" },
    { field: "date_start", label: "วันที่เริ่ม" },
    { field: "date_end", label: "วันที่สิ้นสุด" },
    { field: "status", label: "สถานะผู้ใช้งาน" }
  ];

  const handleHeaderClick = (value, index, inversed) => {
    setIndexSort(index)
    setInversedSort(inversed)
    fetchUserData(value, inversed ? "DESC" : "ASC")
  }

  const headerStyles = {
    verticalAlign: "middle",
    whiteSpace: "nowrap",
    cursor: "pointer",
    transition: "background-color 0.3s",
  }

  const sortIcon = (index) => {
    return (
      <i className={`ps-2 ${indexSort === index ? `fa-duotone fa-sort-${inversedSort ? "down" : "up"}` : "text-secondary fa-regular fa-sort"}`}/>
    );
  }

  const hoverEffect = (e, inOut) => {
    e.target.style.backgroundColor = inOut ? "rgba(215,218,222,0.6)" : "rgba(239,242,247,1)"
  }

  const handleModal = (toggle, id, userID, org) => {
    setconfirmModal(toggle)
    setId(id)
    setOrgId(org)
    setUserID(userID)
  }

  useEffect(() => {
    if (userInfo) {
      if (
        !CheckPosition(userInfo?.position) &&
        !CheckSubAdmin(userInfo?.positionSubAdmin)
      ) 
      {
        navigate("/setdata");
      }
    }
  }, [userInfo]);

  return (
    <Fragment>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "400px",
          }}
        >
          <LoadingData />
        </div>
      ) : (
        <FadeIn>
          <Row className="mb-3">
            <Col xs={12} md={10} lg={6} className="mt-2">
              <InputGroup>
                <Input
                  type="search"
                  value={keyword}
                  style={{ width: "40%" }}
                  placeholder="ค้นหาเจ้าหน้าที่"
                  onChange={e => setKeyword(e.target.value)}
                  onKeyDown={handleKeyDown}
                />
                <Button
                  style={{ display: "flex", alignItems: "center" }}
                  color="primary"
                  onClick={handleSearch}
                >
                  <i className="fa-sharp fa-solid fa-magnifying-glass fa-xl"></i>
                </Button>
              </InputGroup>
            </Col>
            <Col xs={12} md={2} lg={6} style={{ display: "flex", justifyContent: "end" }} className="mt-2">
              <AddCommander onButtonClick={handleButtonClick} />
            </Col>
          </Row>
          <Row>
            <Col>
              <Table
                className="align-middle"
                striped
                style={{
                  overflow: "scroll",
                  fontSize: "15px"
                }}
                responsive
              >
                <thead className="table-light" style={headerStyles}>
                  <tr>
                    <th>ลำดับ</th>
                    {headers.map((header, index) => (
                      <th key={index} onMouseEnter={(e) => hoverEffect(e, true)} onMouseLeave={(e) => hoverEffect(e, false)} onClick={() => handleHeaderClick(header.field, index, !inversedSort)}>
                      {header.label}{sortIcon(index)}
                    </th>
                    ))}
                    <th>{/* <i className="fa-solid fa-envelope"></i> */}</th>
                  </tr>
                </thead>

                <tbody>
                  {userData.length === 0 ? (
                    <tr>
                      <td colSpan="7" className="text-center fs-5">
                        ไม่มีข้อมูล
                      </td>
                    </tr>
                  ) : (
                    userData.map((user, index) => {
                      let cp = (currentPage - 1) * 10;
                      return (
                        <tr key={index} >
                          <td>{index + cp + 1}</td>
                          <td className="text-nowrap">{user.user_name}</td>
                          <td>
                            {user.org_name === null ? (
                              <td>กรุณากรอกข้อมูลของสำนัก/กอง/กลุ่ม ในการแก้ไข</td>
                            ) : (
                              <td>
                                {user.org_name}
                                {user.assign == 1 && (user.assign_type &&
                                (user.assign_type == 0)
                                  ? " (รักษาราชการแทน)"
                                  : " (ปฎิบัติราชการแทน)" )}
                              </td>
                            )}
                          </td>

                          <td>{user.position_name}</td>

                          <td>
                            {
                            
                            user.date_start === null ? (
                              <td>กรุณาแก้ไข</td>
                            ) : (
                              <td>
                                     {dayjs
                                    .utc(user.date_start).add(543,"year")
                                    .format("DD/MM/YYYY")}
                              </td>
                            )}
                          </td>

                          <td>
                            {user.date_end === null ? (
                              ""
                            ) : (
                              <td>
                                     {dayjs
                                    .utc(user.date_end).add(543,"year")
                                    .format("DD/MM/YYYY")}
                              </td>
                            )}
                          </td>

                          <td>
                            {user.status === 1 ? (
                              <Badge
                                color="success"
                                className="p-2 bg-opacity-10"
                              >
                                <span className="text-success fs-6">
                                  ใช้งาน
                                </span>
                              </Badge>
                            ) : (
                              <Badge
                                color="danger"
                                className="p-2 bg-opacity-10"
                              >
                                <span className="text-danger fs-6">
                                  ไม่ใช้งาน
                                </span>
                              </Badge>
                            )}
                          </td>

                          <td>
                            <EditCommander
                              id={parseInt(user.id)}
                              userDataID={user.user_id}
                              OrgUserBase={user.org_id}
                              ISdefaultSocheck={user.is_default}
                              onButtonClick={handleButtonClick}
                            />

                            <Button
                              className="mt-1"
                              color="danger"
                              onClick={() => {
                                handleModal(true, user.id, user.user_id, user.org_id)
                              }}
                            >
                              <i className="fa-solid fa-trash"></i>
                            </Button>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </Table>
              <ConfirmModal
                 modal = {confirmModal}
                 modalSize = "md"
                 modalHeaderContent = "คุณต้องการที่จะลบ ใช่หรือไม่?"
                 onClickConfirmBtn={() => {
                  fetchDeleteData(id, userID, orgId);
                  deleteState(id);
                  setconfirmModal(false)
                 }}
                 onClickCancelBtn={() => {
                   setconfirmModal(false)
                 }}
                />
              <Row
                className="mx-2"
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
               <Col xxl={4}>
                  <h4 className="mb-0">
                    <Badge className="badge-soft-primary me-1 fs-5">
                      ทั้งหมด {dataInfo?.totalRows} รายการ
                    </Badge>
                  </h4>
                </Col>
                <Col xxl={8} className="d-flex justify-content-center justify-content-sm-end">
                  <Pagination className="mt-3">
                    <PaginationItem disabled={currentPage === 1}>
                      <PaginationLink onClick={() => setCurrentPage(1)}>
                        หน้าแรก
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem disabled={currentPage === 1}>
                      <PaginationLink
                        onClick={() => setCurrentPage(currentPage - 1)}
                      >
                        ย้อนกลับ
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem active>
                      <PaginationLink>หน้า {currentPage} จาก {totalPages}</PaginationLink>
                    </PaginationItem>
                    <PaginationItem
                      disabled={
                        currentPage === dataInfo.totalPage || totalPages === 0
                      }
                    >
                      <PaginationLink
                        onClick={() => setCurrentPage(dataInfo.currentPage + 1)}
                      >
                        ถัดไป
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem
                      disabled={currentPage === totalPages || totalPages === 0}
                    >
                      <PaginationLink
                        onClick={() => setCurrentPage(dataInfo.totalPage)}
                      >
                        หน้าสุดท้าย
                      </PaginationLink>
                    </PaginationItem>
                  </Pagination>
                </Col>
              </Row>
            </Col>
          </Row>
        </FadeIn>
      )}
    </Fragment>
  );
}

export default ViewCommander;
